import { Component, OnInit } from '@angular/core';
import {
  ReporteVentaService,
  UserService,
  AuthenticationService
} from '@app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from '@core/service/client.service';
import { Client } from '@core/model/client.model';
import { User } from '@app/core/model/user.model';
import { ReporteService } from '@app/core/service/reporte.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-venta',
  templateUrl: './venta.component.html',
  styleUrls: ['./venta.component.css']
})
export class VentaComponent implements OnInit {
  buscarForm: FormGroup;
  existencia: any;
  users: User[];
  isLoading = false;

  totalSum = 0;
  tcompra = 0;
  tganancia = 0;

  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;

  constructor(
    private ventaService: ReporteVentaService,
    private clientService: ClientService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private reporteService: ReporteService,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.createForm();
    this.listVenta();
    // this.listData();
    this.listVendedores();

    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user.data.user.id;
        //  console.log(this.currentUser.data.user);
        this.userid = this.currentUser;
      }
    );
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      inicio: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      fin: [new Date().toISOString().substring(0, 10), [Validators.required]],

      vendedor: ['', [Validators.nullValidator]],
      producto: ['', [Validators.nullValidator]]
      /*   categoria: ['',[Validators.required]],
         producto:['',[Validators.required]]*/
    });
  }
  listVendedores() {
    this.userService.getAllVendedores().subscribe(
      data => {
        this.users = data;
        console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  public calculateTotal() {
    return this.existencia.reduce(
      (accum: any, curr: any) => accum + curr.total,
      0
    );
  }
  public calculateTotalC() {
    return this.existencia.reduce(
      (accum: any, curr: any) => accum + curr.total2,
      0
    );
  }
  public calculateTotalG() {
    return this.existencia.reduce(
      (accum: any, curr: any) => accum + curr.ganancia,
      0
    );
  }

  listData() {
    this.clientService.getClientesHabilitados().subscribe(
      data => {
        console.log(data);
        // this = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  listVenta() {
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();

    const data2 = {
      cliente_id: this.userid,
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia
    };

    this.reporteService.ventaProductos(data2).subscribe(
      data => {
        console.log(data);
        this.existencia = data;
        this.totalSum = this.calculateTotal();
        this.tcompra = this.calculateTotalC();
        this.tganancia = this.calculateTotalG();
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia() {
    console.log(this.buscarForm.value.vendedor);
    let id: string;
    if (this.buscarForm.value.vendedor === '') {
      id = null;
    } else {
      id = this.buscarForm.value.vendedor;
    }

    const data = {
      cliente_id: id,
      fecha_inicio: this.buscarForm.value.inicio,
      fecha_final: this.buscarForm.value.fin
    };

    //  console.log(data);
    this.reporteService.ventaProductos(data).subscribe(
      data2 => {
        console.log(data2);
        this.existencia = data2;
        this.totalSum = this.calculateTotal();
        this.tcompra = this.calculateTotalC();
        this.tganancia = this.calculateTotalG();
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  findDetalle(id: string) {
    this.ventaService.getById(id).subscribe(data => {
      console.log(data);
    });
  }
}
